import React from 'react'
import styled from 'styled-components';
import SquareButton from '../../../components/squareButton';

const TITLE_WRAPPER = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;    
    height:30px;
    padding-left:20px ;
    padding-right:20px ;
    margin-bottom: 4px;

    @media(min-width: 1024px){
        height: 46px;
    }
    cursor: pointer;
    .title{
        margin-right: 30px;
        font-size:12px ;
        color: var(--main-text-color);
        letter-spacing: 0.17px;
        @media(min-width: 1024px){
            font-size:17px;
            font-weight: 700;
        }
        @media(min-width: 1420px){
            font-size:18px;
        }
    }
    .border{
        height: 1px;
        background-color: var(--main-explosive);
        flex-grow: 1;
    }
`;

export default function Title({ title, buttonText, onClick, style }) {
    return (
        <TITLE_WRAPPER style={{...style}}>
            <span className='title'>{title}</span>
            <span className='border'></span>
            <SquareButton text={buttonText} onClick={onClick} />
        </TITLE_WRAPPER>
    )
}
